module.exports = __webpack_public_path__ + "img/icon-decoration1.4ea4d338.png";